import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import { RecruitmentResultTrainingLeftMenuList } from "../utils/constants";

const KMC_Training = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="img" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {RecruitmentResultTrainingLeftMenuList.map(
                      (item, index) => (
                        <RenderNavItem
                          key={item.id || index}
                          item={item}
                          index={index}
                          t={t}
                        />
                      )
                    )}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("KMC Training")} </h3>
                  </div>
                  <div className=" health-dept-table">
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      cellPadding={2}
                      cellSpacing={2}
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr
                          bgcolor="#302ba0"
                          tabIndex={0}
                          align="center"
                          valign="middle"
                        >
                          <td
                            width="90%"
                            className="text-white tble-brder-left"
                          >
                            {t("Description")}
                          </td>
                          <td width="10%" className="text-white">
                            {t("Date")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"5759ff5e-9719-455d-badd-7f88e95f0d33"}&tenantId=km.kolkata`}
                            >
                              {t(
                                "Training schedule at IUM for KMC Jr.Asst, SAE and AE"
                              )}
                            </a>
                          </td>
                          <td>12.06.2019</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="90%">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"607d49a9-6223-46be-8ebf-9374395cd275"}&tenantId=km.kolkata`}
                            >
                              {t(
                                "Communique from DG(IUM) for the KMC Employees who participated in the training program between 24.06.2019 and 29.06.2019"
                              )}
                            </a>
                          </td>
                          <td width="10%">15.07.2019</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KMC_Training;
